/**
 * Aviso visible para todos cuando el cliente ya llegó al tope de bolívares de hoy en notas (pedido de la dueña
 * 19-10-2026: el sistema no dejaba pagar en Bs la diferencia de un cambio y no decía por qué). Solo pantalla: usa lo que
 * el servidor ya calculó (`bs_notas`) y no cambia el tope ni ninguna cuenta. Habla en dólares: el tope en Bs dejaría ver
 * la tasa 2, que solo ve la dueña (pedido de la dueña 2026-10-19).
 */
import { formatearUsd, Money, type BsNotasHoyDTO } from '@mg/shared';

/** ¿Hoy ya no puede pagar más en bolívares en notas? (llegó al máximo de notas con Bs o no le queda tope). */
export function topeBsNotasLleno(b: BsNotasHoyDTO | null | undefined): b is BsNotasHoyDTO {
  return !!b && (!b.admite_otra || !Money.parse(b.disponible_usd).esPositivo());
}

export function AvisoTopeBsNotas({ bsNotas, queSeCobra = 'Lo que falta', testid = 'aviso-tope-bs' }: { bsNotas: BsNotasHoyDTO | null | undefined; queSeCobra?: string; testid?: string }) {
  if (!topeBsNotasLleno(bsNotas)) return null;
  const motivo = !bsNotas.admite_otra
    ? `Este cliente ya tiene ${bsNotas.notas} nota(s) con pago en bolívares hoy (máximo ${bsNotas.maximo_notas} por día).`
    : `Este cliente ya llegó al tope de bolívares de hoy en notas: ya pagó ${formatearUsd(Money.parse(bsNotas.usado_usd))} en bolívares en ${bsNotas.notas} nota(s).`;
  return (
    <p role="status" className="rounded-lg border border-mg-ambar bg-amber-50 px-3 py-1.5 text-xs font-medium text-amber-900" data-testid={testid}>
      {motivo} {queSeCobra} se cobra en dólares: efectivo $, Zelle o USDT.
    </p>
  );
}
